<template>
  <section class="section section_bg custom_page_v2 section_black">
    <loading-block v-if="isload==false" :loading="!isload"/>
    <div class="section_header mobile_div back_div_element" v-if="isload"   >
      <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

    </div>
<div class="section_header mobile_div nocenter" v-if="isload">
  <tabs @tabchange="onTabChange" :activeTab="activeTab" :value="activeTab" fill class=" flex-column flex-md-row tabs_style">
    <div shadow  class="mobile_div">
      <tab-pane class="" title="works">
            <span slot="title">

                Работы
            </span>
        <div class="">
          <div class="row mb-3">
            <div class="col-12 text-left">
              <p><router-link tag="a" class="btn" :to="{name: 'add_portfolio'}">
                Добавить
              </router-link>
              </p>
            </div>
          </div>
          <div class="" v-if="data.length>0">
            <card class="mt-1 section_gray_bg" v-for="(row,row_index) in data" :key="row_index">
              <div class="row m-3">
                <div class="col-12 col-lg-6 col-md-6">
                  <p><router-link  tag="a"
                      :to="{name: 'user_page_one_portfolio', params: { user_id: row.user_id,work_id:row.last_id }}">{{ row.name }}</router-link></p>
                  <p>{{ row.category.name }}</p>
                </div>
                <div class="col-12 col-lg-6 col-md-6 mt-1">
                  <p><router-link tag="a" class="btn" :to="{name: 'edit_portfolio', params: { id: row.last_id }}">
                    <i class="fa fa-edit"></i>
                  </router-link> </p>
                  <p>  <button
                      class="btn" @click="deleteItem(row_index)">
                    Удалить
                  </button></p>

                </div>
              </div>

            </card>
          </div>

        </div>

      </tab-pane>
      <tab-pane title="settings">
            <span slot="title">

                Услуги
            </span>

        <div v-if="services && services.length>0" class="text-center ml-5 mb-5">

          <p v-for="(service,service_index) in services" :key="'service'+service_index" >
            <router-link tag="a" class="btn" :to="{name: 'setup_service',params: { id: service.last_id }}">
              {{ service.name}} <i class="fa fa-plus-circle"></i>
            </router-link>

          </p>

        </div>

      </tab-pane>




    </div>
  </tabs>


</div>
  </section>

</template>

<script>
import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import Modal from "@/components/Modal";
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import TabPane from "@/components/Tabs/TabPane";


export default {
  name: "Portfolio",
  components: {LoadingBlock,Tabs,Tab,TabPane},
  data() {
    var app = this;
    return {
      "loaded_categorys": false,
      "categorys": null,
      "isload":false,
      'activeTab':"works",
      "services":[],
      data: [],
    }
  },
  mounted: function () {
    var app=this;
    if(app.$route.query && app.$route.query.tab_active ){
      app.activeTab=app.$route.query.tab_active;
    }
    Api.loadAccount(function(data){

      app.services=data.services;

    })
    Api.loadPortfolioCategorys();
    Api.loadUserPortfolio();

    eventBus.$on('load_portfolio_user', portfolio_rows => {
      this.data = portfolio_rows;
      this.isload=true;


    });

    eventBus.$on('load_portfolio_categorys', categorys => {
      this.categorys = categorys;
      this.loaded_categorys = true;

    });
  },
  methods:{
    onTabChange(tab_active){
      this.activeTab=tab_active;
    },
    deleteItem(index){
      var row=this.data[index];
      Api.deleteUserPortfolio(row.last_id);

      this.data.splice(index, 1);
    }
  }
}
</script>

<style scoped>

</style>